import {Injectable} from '@angular/core';
import {MODAL_WITHOUT_BACKDROP_OPTION} from '@constants/modal-options/modal-options';
import {NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {NavigationStart, Router} from '@angular/router';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private subscription: Subscription = new Subscription();
  constructor(private modalService: NgbModal, private router: Router) {
    this.closeModalOnRouteChange();
  }

  open(content: any, options?: NgbModalOptions): NgbModalRef {
    if(options) {
      options.backdrop = MODAL_WITHOUT_BACKDROP_OPTION.backdrop;
    } else {
      options = MODAL_WITHOUT_BACKDROP_OPTION;
    }
    return this.modalService.open(content, options);
  }

  private closeModalOnRouteChange() {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && this.modalService.hasOpenModals()) {
        this.modalService.dismissAll(ModalDialogDismissOption.CANCEL);
        this.subscription.unsubscribe();
        this.closeModalOnRouteChange();
      }
    });
  }
}
